module.exports = __webpack_public_path__ + "static/bg-element-4-b0fdacd54f21b4aff4a9ce98698f5ee0.png";